export const UPDATE_VIEWPORT = 'ui/updateViewport';
export const updateViewport = (height, width) => ({
  type: UPDATE_VIEWPORT,
  payload: {
    height,
    width,
  },
});
